import { render, staticRenderFns } from "./ChatBoxModalWhatsappTemplate.vue?vue&type=template&id=41848e31&scoped=true&"
import script from "./ChatBoxModalWhatsappTemplate.vue?vue&type=script&lang=js&"
export * from "./ChatBoxModalWhatsappTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxModalWhatsappTemplate.vue?vue&type=style&index=0&id=41848e31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41848e31",
  null
  
)

export default component.exports